import { ContractNegotiationVersionConcept } from '../../models/Entities/Contracts/ContractNegotiationVersionConcept';
import { NewContractNegotiationVersionConcept } from '../../models/Entities/Contracts/NewContractNegotiationVersionConcept';
import { ErrorType } from '../../models/HttpError';
import * as Services from '../../services/ContractNegotiationVersionConcept.Services';
import * as Actions from '../actions';
import { AppThunkAction } from '../reducers';

type KnownAction =
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetAll_Request_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetAll_Receive_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetAll_Error_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetById_Request_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetById_Receive_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_GetById_Error_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Create_Request_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Create_Receive_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Create_Error_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Update_Request_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Update_Receive_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Update_Error_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Delete_Request_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Delete_Receive_Action
  | Actions.ContractNegotiationVersionConcept.ContractNegotiationVersionConcept_Delete_Error_Action;

const GetUnauthorizedError = (): ErrorType => ({
  ErrorCode: 401,
  ErrorMessage: 'Not authorized',
  Errors: [],
});

export const actionCreators = {
  GetContractNegotiationVersionConcepts:
    (contractNegotiationVersionId: string, contractNegotiationId: string, contractId: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_ALL_ERROR_ACTION', contractNegotiationVersionId, contractNegotiationId, contractId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_ALL_REQUEST_ACTION', contractNegotiationVersionId, contractNegotiationId, contractId });

      Services.GetContractNegotiationVersionConcepts(contractNegotiationVersionId, token)
        .then((contractNegotiationVersionConcepts: ContractNegotiationVersionConcept[]) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_ALL_RECEIVE_ACTION', contractNegotiationVersionConcepts, contractNegotiationVersionId, contractNegotiationId, contractId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_ALL_ERROR_ACTION', contractNegotiationVersionId, contractNegotiationId, contractId, error })
        );
    },

  GetContractNegotiationVersionConceptById:
    (id: string, contractId: number, contractNegotiationId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_BY_ID_ERROR_ACTION', id, contractId, contractNegotiationId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_BY_ID_REQUEST_ACTION', id, contractId, contractNegotiationId });

      Services.GetContractNegotiationVersionConceptById(id, token)
        .then((contractNegotiationVersionConcept: ContractNegotiationVersionConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_BY_ID_RECEIVE_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_GET_BY_ID_ERROR_ACTION', id, contractId, contractNegotiationId, error })
        );
    },

  CreateContractNegotiationVersionConcept:
    (contractNegotiationVersionConcept: NewContractNegotiationVersionConcept, contractId: number, contractNegotiationId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_CREATE_ERROR_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_CREATE_REQUEST_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId });

      Services.CreateContractNegotiationVersionConcept(contractNegotiationVersionConcept, token)
        .then((saved: ContractNegotiationVersionConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_CREATE_RECEIVE_ACTION', contractNegotiationVersionConcept: saved, contractId, contractNegotiationId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_CREATE_ERROR_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId, error })
        );
    },

  UpdateContractNegotiationVersionConcept:
    (contractNegotiationVersionConcept: ContractNegotiationVersionConcept, contractId: number, contractNegotiationId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_UPDATE_ERROR_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_UPDATE_REQUEST_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId });

      Services.UpdateContractNegotiationVersionConcept(contractNegotiationVersionConcept, token)
        .then((updated: ContractNegotiationVersionConcept) => {
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_UPDATE_RECEIVE_ACTION', contractNegotiationVersionConcept: updated, contractId, contractNegotiationId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_UPDATE_ERROR_ACTION', contractNegotiationVersionConcept, contractId, contractNegotiationId, error })
        );
    },

  DeleteContractNegotiationVersionConcept:
    (id: string, contractId: number, contractNegotiationId: string, contractNegotiationVersionId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      const token = state.oidc?.user?.access_token;

      if (!token) {
        dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_DELETE_ERROR_ACTION', id, contractId, contractNegotiationId, contractNegotiationVersionId, error: GetUnauthorizedError() });
        return;
      }

      dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_DELETE_REQUEST_ACTION', id, contractId, contractNegotiationId, contractNegotiationVersionId });

      Services.DeleteContractNegotiationVersionConcept(id, token)
        .then(() => {
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_DELETE_RECEIVE_ACTION', id, contractId, contractNegotiationId, contractNegotiationVersionId });
        })
        .catch((error: ErrorType) =>
          dispatch({ type: 'CONTRACTNEGOTIATIONVERSIONCONCEPT_DELETE_ERROR_ACTION', id, contractId, contractNegotiationId, contractNegotiationVersionId, error })
        );
    },
};
